import type { LbOptions } from './types';

export const defaults: LbOptions = {
  host: null,
  basePath: '/api/v2/',
  apiKey: null,
  urls: {
    posts: 'blogs/{blogId}/posts',
    events: 'blogs/{blogId}/events',
  },
  debug: /lbdebug/i.test(document.location.search),
  transport: {
    filter: null,
  },
  customComponents: {},
  autostart: false,
  showLoadMore: true,
  useSkeletonPosts: false,
  useLoadingSkeletonPosts: false,
  hideNewPosts: true,
  showNewPostsOnScroll: true,
  scrollThreshold: '30%',
  refreshRate: 5000,
  limit: 25,
  match: null,
};
